/* eslint-disable max-lines */
import { receiveNewKeyword } from 'actions/identifier';
import ToggleButton from 'components/ToggleButton';
import WarningMsg from 'components/WarningMsg';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  getActiveLanguageMatcher,
  getActiveLanguageMatcherId,
  getCompareMode,
  getLanguageMatcherTypes,
  getShouldDisableEdit,
  saveIdentifierRequestLoading,
  unsavedChanges,
} from 'selectors/identifier';
import { useSelector } from 'store';
import { languageMatcherNotificationMsgs } from 'utils/userNotificationMsgs';
import AddLanguageMatcherInput from '../AddLanguageMatcherInput';
import TermsInput from '../AddLanguageMatcherInput/TermsInput';
import ChooseCombinationType from '../ChooseCombinationType';
import DeleteMatcherButton from '../DeleteMatcherButton';
import LanguageMatcherHeader from '../LanguageMatcherHeader';

type LanguageMatcherType = {
  isSaved: boolean;
};

const RegexTypeForm: React.FC<LanguageMatcherType> = ({ isSaved }) => {
  const dispatch = useDispatch();

  const unsaved = useSelector(unsavedChanges);
  const activeLanguageMatcher = useSelector(getActiveLanguageMatcher);
  const activeLanguageMatcherId = useSelector(getActiveLanguageMatcherId);
  const isLoadingSaveIdentifier = useSelector(saveIdentifierRequestLoading);
  const languageMatcherTypes = useSelector(getLanguageMatcherTypes);
  const compareMode = useSelector(getCompareMode);
  const shouldDisable = useSelector(getShouldDisableEdit);

  const regexExcludedFields = ['is_exclusion', 'patterns', 'flags', 'team_uuids', 'not_team_uuids'];

  useEffect(() => {
    if (activeLanguageMatcher && activeLanguageMatcher.isNew) {
      const input = document.getElementById('name');
      input?.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeLanguageMatcherId]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleToggleClick = (field: string): void => {
    // @ts-ignore
    const value = !activeLanguageMatcher[field];

    dispatch(
      receiveNewKeyword({
        languageMatcherId: activeLanguageMatcherId,
        parentType: 'regex',
        data: {
          // @ts-ignore
          key: field,
          value,
        },
      })
    );

    dispatch(
      receiveNewKeyword({
        languageMatcherId: activeLanguageMatcherId,
        parentType: 'regex',
        data: {
          key: 'saved',
          value: false,
        },
      })
    );
  };

  if (Object.keys(languageMatcherTypes).length === 0) return null;

  return (
    <div className="flex flex-col pt-5 pl-10 pr-4 pb-6 text-body h-full">
      <div className="flex flex-row justify-end">
        <WarningMsg
          message={languageMatcherNotificationMsgs.unsavedChanges}
          showLoading={isLoadingSaveIdentifier}
          showWarning={unsaved}
          showSavedMsg={isSaved}
        />
      </div>
      <div className="-mt-4 flex flex-col gap-4 text-body h-full">
        <LanguageMatcherHeader />
        <div className="mt-6 flex flex-row items-center gap-3">
          <ToggleButton
            // @ts-ignore
            isOn={activeLanguageMatcher.is_exclusion as boolean}
            handleToggleClick={(): void => handleToggleClick('is_exclusion')}
            disabled={compareMode || shouldDisable}
          />
          <span>Exclude matches</span>
        </div>
        <div className="flex flex-row gap-1">
          <div className="w-full">
            <TermsInput
              languageMatcherId={activeLanguageMatcherId}
              type="regex"
              // @ts-ignore
              form="patterns"
              renderNegated
            />
          </div>
        </div>

        <div className="flex flex-row gap-5 mt-6">
          <div className="w-1/2">
            <AddLanguageMatcherInput
              languageMatcherId={activeLanguageMatcherId}
              type="regex"
              // @ts-ignore
              form="flags"
            />
          </div>
        </div>
        <div className="flex flex-col gap-4">
          <TermsInput
            languageMatcherId={activeLanguageMatcherId}
            type="regex"
            // @ts-ignore
            form="team_uuids"
          />

          <TermsInput
            languageMatcherId={activeLanguageMatcherId}
            type="regex"
            // @ts-ignore
            form="not_team_uuids"
            useDisabledColor
          />
        </div>
        <div>
          <ChooseCombinationType
            activeLanguageMatcher={activeLanguageMatcher}
            excludedFields={regexExcludedFields}
          />
        </div>

        <div className="mt-auto pt-6 flex flex-row justify-end">
          <DeleteMatcherButton
            text="Delete Matcher"
            setValue={(): void => {
              // moot
            }}
            setHighlightedLanguageMatcher={(): void => {
              // moot
            }}
            activeLanguageMatcher={activeLanguageMatcher}
          />
        </div>
      </div>
    </div>
  );
};

export default RegexTypeForm;
